/**
 * Returns the current timezone of the user's browser.
 */
export const currentTimeZone = (() => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return '';
  }
})();
